<ion-header><app-page-header subtitle="Breweries"></app-page-header></ion-header>

<ion-content>
  <brewery-list-card [breweries]="breweries" [showSearchbar]="true" [showBreweries]="true" [add]="user.isAdmin"></brewery-list-card>
</ion-content>
